/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyStockIndentItem from './pharmacy-stock-indent-item';
import PharmacyStockIndentItemDetail from './pharmacy-stock-indent-item-detail';
import PharmacyStockIndentItemUpdate from './pharmacy-stock-indent-item-update';
import PharmacyStockIndentItemDeleteDialog from './pharmacy-stock-indent-item-delete-dialog';

const PharmacyStockIndentItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyStockIndentItem />} />
    <Route path="new" element={<PharmacyStockIndentItemUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyStockIndentItemDetail />} />
      <Route path="edit" element={<PharmacyStockIndentItemUpdate />} />
      <Route path="delete" element={<PharmacyStockIndentItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyStockIndentItemRoutes;
